export interface StoredSession {
  token: string;
  courseId: string;
}

// Guarda o token Basic Auth junto do courseId resolvido pelo backend — não dá
// mais pra assumir 1 courseId fixo por deploy quando um login pode ter acesso
// a mais de uma lista (institution+courseId) e escolhe qual usar no login.
export class AuthStorageDatasource {
  private key(institution: string): string {
    return `authSession:${institution.toUpperCase()}`;
  }

  getSession(institution: string): StoredSession | null {
    const raw = sessionStorage.getItem(this.key(institution));
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as Partial<StoredSession>;
      if (!parsed.token || !parsed.courseId) return null;
      return { token: parsed.token, courseId: parsed.courseId };
    } catch {
      return null;
    }
  }

  saveSession(institution: string, session: StoredSession): void {
    sessionStorage.setItem(this.key(institution), JSON.stringify(session));
  }

  clearSession(institution: string): void {
    sessionStorage.removeItem(this.key(institution));
  }
}
